export default "__VITE_ASSET__NDpRNyPY__"